import React, { useState, useMemo } from "react";
import queries from "../helpers/queries";
import { useQuery } from "@apollo/react-hooks";
import { withRouter } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import { withUser } from "../Contexts/user";
const Album = withRouter(({ user, history }) => {


    const [selectedImage, setSelectedImage] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const itemsPerPage = 12;

    const openModal = (image, index) => {
        setSelectedImage(image);
        setCurrentImageIndex(index);
        setShowModal(true);
        // Prevent body scrolling when modal is open
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedImage(null);
        // Re-enable body scrolling
        document.body.style.overflow = 'auto';
    };

    const navigateImage = (direction) => {
        const newIndex = direction === 'next' 
            ? (currentImageIndex + 1) % currentProjects.length 
            : (currentImageIndex - 1 + currentProjects.length) % currentProjects.length;
        
        setCurrentImageIndex(newIndex);
        setSelectedImage(currentProjects[newIndex].url);
    };

    const { data: bannersData } = useQuery(queries.FETCH_BANNERS_AGENT, {
        variables: {
            isMobile: window.innerWidth < 600 ? true : false,
            agent: user ? user.auth.userId : undefined,
        },
        fetchPolicy: "network-only",
    });


    const filteredProjects = useMemo(() => {
        if (!bannersData?.fetchBannersAgent.length) return [];
        return bannersData.fetchBannersAgent;
    }, [bannersData]);

    const currentProjects = filteredProjects.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    ).flat();

    return (
        <div className="lg:flex">
            <div className="w-full team-card album-page">
                <div className="namecard-header-row album-page-header">
                    <button
                        type="button"
                        className="namecard-back-btn namecard-download-btn"
                        onClick={() => history.goBack()}
                        aria-label="Go back"
                    >
                        <FaArrowLeft aria-hidden />
                        Back
                    </button>
                </div>
                <div className="album-grid">
                    {currentProjects.map((item, i) => (
                        <div key={i} className="album-item" onClick={() => openModal(item.url, i)}>
                            <img
                                className="album-item-image"
                                src={item.url}
                                alt={item.name || 'Banner image'}
                            />
                        </div>
                    ))}
                </div>
            </div>
            
            {/* Image Modal */}
            {showModal && (
                <div className="image-modal-overlay" onClick={closeModal}>
                    <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
                        <img 
                            src={selectedImage} 
                            alt="Enlarged view" 
                            className="image-modal-img" 
                        />
                        <button 
                            className="image-modal-nav image-modal-prev" 
                            onClick={(e) => {
                                e.stopPropagation();
                                navigateImage('prev');
                            }}
                        >
                            &#10094;
                        </button>
                        <button 
                            className="image-modal-nav image-modal-next" 
                            onClick={(e) => {
                                e.stopPropagation();
                                navigateImage('next');
                            }}
                        >
                            &#10095;
                        </button>
                        <button className="image-modal-close" onClick={closeModal}>
                            &times;
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
});

export default withUser(Album);
